(() => {
 if (customElements.get('elite-product-shelf')) return;
 class EliteProductShelf extends HTMLElement {
  connectedCallback() {
   if (this.started) return;
   this.started = true;
   this.controller = new AbortController();
   this.querySelector('[data-clear-recent]')?.addEventListener('click', () => {
    try { localStorage.removeItem('recentlyViewedProducts'); } catch (_) {}
    this.hidden = true;
   }, {signal:this.controller.signal});
   if (this.dataset.kind === 'recent') {
    this.load();
   } else if (this.dataset.auto === 'true') {
    if (this.hidden) { this.load(); } else if ('IntersectionObserver' in window) {
     this.observer = new IntersectionObserver(entries => {
      if (entries.some(entry => entry.isIntersecting)) { this.observer.disconnect(); this.load(); }
     }, {rootMargin:'350px'});
     this.observer.observe(this);
    } else this.load();
   }
  }
  disconnectedCallback() { this.observer?.disconnect(); this.controller?.abort(); this.started = false; }
  async load() {
   const recent = this.dataset.kind === 'recent';
   const url = new URL(this.dataset.url, location.origin);
   url.searchParams.set('section_id', this.dataset.sectionId);
   if (recent) {
    let ids;
    try {
     const stored = JSON.parse(localStorage.getItem('recentlyViewedProducts') || '[]');
     ids = Array.isArray(stored) ? [...new Set(stored.map(String))].filter(id => /^\d+$/.test(id) && id !== this.dataset.currentProduct).slice(0,18) : [];
    } catch (_) { ids = []; }
    if (!ids.length) return;
    url.searchParams.set('type','product');
    url.searchParams.set('q',ids.map(id => `id:${id}`).join(' OR '));
   } else {
    url.searchParams.set('product_id',this.dataset.currentProduct);
    url.searchParams.set('limit','10');
    url.searchParams.set('intent','related');
   }
   try {
    const response = await fetch(url, {credentials:'same-origin',signal:this.controller.signal});
    if (!response.ok) return;
    const html = new DOMParser().parseFromString(await response.text(),'text/html');
    const shelf = html.querySelector(`elite-product-shelf[data-kind="${this.dataset.kind}"]`);
    const source = shelf?.querySelector('[data-shelf-cards]');
    if (!source?.querySelector('.eds-card')) return;
    const ids = new Set();
    const cards = [...source.querySelectorAll('.eds-card')].filter(card => {
     const id = card.dataset.productId;
     if (id === this.dataset.currentProduct || ids.has(id)) return false;
     ids.add(id); return true;
    }).slice(0,Number(this.dataset.limit) || 4);
    if (!cards.length) return;
    const target = this.querySelector('[data-shelf-cards]');
    const before = [...target.querySelectorAll('.eds-card')].map(card => card.dataset.productId).join(',');
    const after = cards.map(card => card.dataset.productId).join(',');
    if (before !== after) target.replaceChildren(...cards);
    target.style.setProperty('--eds-columns',Math.min(cards.length,4));
    this.dataset.source = recent ? 'history' : shelf.dataset.source;
    this.hidden = false;
   } catch (_) {}
  }
 }
 customElements.define('elite-product-shelf',EliteProductShelf);
})();
